module.exports = __webpack_public_path__ + "static/media/true_detective.76b94180.jpg";